import { ColumnType } from '../../../../components/Grid/constants';
import { RealtyType, OtherContractType, Visibility } from '../../enum';

export const defaultCols = [
  {
    field: 'name',
    label: 'Název',
    type: ColumnType.TEXT,
    width: '80%'
  },
  {
    field: 'created',
    label: 'Vytvořen',
    type: ColumnType.DATE,
    width: '20%'
  },
];

export const workingPositionCols = [
  {
    field: 'name',
    label: 'Název',
    type: ColumnType.TEXT,
    width: '40%'
  },
  {
    field: 'organization.name',
    displayField: 'organization',
    label: 'Organizace',
    type: ColumnType.TEXT,
    mapper: field => field ? field.name : '',
    width: '25%'
  },
  {
    field: 'visibility.name',
    displayField: 'visibility',
    label: 'Přístupnost funkce',
    type: ColumnType.ENUM,
    enum: Visibility,
    width: '20%'
  },
  {
    field: 'created',
    label: 'Vytvořen',
    type: ColumnType.DATE,
    width: '15%'
  },
];

export const realtyTypeCols = [
  {
    field: 'name',
    label: 'Název',
    type: ColumnType.TEXT,
    width: '50%'
  },
  {
    field: 'type.name',
    displayField: 'type',
    label: 'Typ nemovité věci',
    type: ColumnType.ENUM,
    enum: RealtyType,
    width: '30%'
  },
  {
    field: 'created',
    label: 'Vytvořen',
    type: ColumnType.DATE,
    width: '20%'
  },
];

export const otherContractCols = [
  {
    field: 'name',
    label: 'Název',
    type: ColumnType.TEXT,
    width: '50%'
  },
  {
    field: 'type.name',
    displayField: 'type',
    label: 'Typ',
    type: ColumnType.ENUM,
    enum: OtherContractType,
    width: '30%'
  },
  {
    field: 'created',
    label: 'Vytvořen',
    type: ColumnType.DATE,
    width: '20%'
  },
];

export const administrativeAuthoritiesCols = [
  {
    field: 'name',
    label: 'Správní orgán',
    type: ColumnType.TEXT,
    width: '40%'
  },
  {
    sortable: false,
    filterable: false,
    field: 'address',
    label: 'Adresa',
    type: ColumnType.JSX,
    width: '40%',
    jsx: ({ address }) => (
      <div>
        {address.street} {address.orientationNumber}, {address.zip} {address.municipality}
      </div>
    )
  },
  {
    field: 'databox',
    label: 'Datová schránka',
    type: ColumnType.TEXT,
    width: '10%'
  },
  {
    field: 'created',
    label: 'Vytvořeno',
    type: ColumnType.DATE,
    width: '10%'
  },
];
